import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { userPrivateRoutesConstants as routesConstants } from "./routesConstants";

import { componentLazyImport } from "modules/core/utils/helpers";

// pages
const UserManagementPage = lazy(() =>
  componentLazyImport(() => import("../../pages/UserManagement"))
);
const UserProfile = lazy(() =>
  componentLazyImport(() => import("../../../user/pages/UserProfile"))
);

const UserPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.user_management.path} exact>
        <UserManagementPage />
      </Route>

      <Route path={routesConstants.user_profile.path} exact>
        <UserProfile />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default UserPrivateRoutes;
